/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type DocumentsTable_delegate = {
    readonly currentBackgroundCheck: {
        readonly idExpiryDate: string | null;
        readonly dbsExpiryDate: string | null;
    } | null;
    readonly documents: {
        readonly edges: ReadonlyArray<{
            readonly uuid: string;
            readonly name: string;
            readonly url: string | null;
            readonly expiryDate: string | null;
            readonly completionDate: string | null;
            readonly getEmail: boolean;
        } | null> | null;
    } | null;
    readonly " $refType": "DocumentsTable_delegate";
};
export type DocumentsTable_delegate$data = DocumentsTable_delegate;
export type DocumentsTable_delegate$key = {
    readonly " $data"?: DocumentsTable_delegate$data;
    readonly " $fragmentRefs": FragmentRefs<"DocumentsTable_delegate">;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "DocumentsTable_delegate",
    "type": "Delegate",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "currentBackgroundCheck",
            "storageKey": null,
            "args": null,
            "concreteType": "BackgroundCheck",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "idExpiryDate",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "dbsExpiryDate",
                    "args": null,
                    "storageKey": null
                }
            ]
        },
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "documents",
            "storageKey": null,
            "args": null,
            "concreteType": "DocumentPage",
            "plural": false,
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Document",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "uuid",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "name",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "url",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "expiryDate",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "completionDate",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "getEmail",
                            "args": null,
                            "storageKey": null
                        }
                    ]
                }
            ]
        }
    ]
} as any);
(node as any).hash = 'b9430ee32d1610b6be4856d2ab1942ff';
export default node;
